/**
 * Polyfill :has() selector for firefox (remove this once more widely supported)
 */
export const partnersFeedHasPolyfill = ({ elWrap }) => {
	const elSubCats = elWrap.querySelector('.partners-feed__control--subcategory')
	const elSubCatsFacet = elSubCats.querySelector('.facetwp-facet')
	// set class instead of :has() for browsers that don't support (*cough* firefox)
	const supportsHas = CSS.supports('selector(:has(*))')
	if (!supportsHas) {
		elSubCats.classList.add('.has-polyfill')
		const checkHas = () => {
			elSubCats.classList.toggle('is-polyfilled', !elSubCatsFacet.childNodes.length)
		}
		checkHas()
		document.addEventListener('facetwp-loaded', checkHas)
	}
	// force repaints for Safari, too... otherwise :has() doesn't paint updates for up to several seconds
	document.addEventListener('facetwp-loaded', () => {
		elSubCats.style.display = 'none'
		elSubCats.offsetHeight
		elSubCats.style.display = ''
	})
}
